// Shared wrapper for /terms and /privacy. Pulls them onto a clean,
// readable, narrow page with the brand header + back link + footer so
// both legal documents have the same look without duplicating chrome.

import React from 'react';
import { Link } from 'react-router-dom';

// v2.5 AD11: when the server's document version is known, the page shows
// it; the constant in server/lib/legal.js is the single source of truth.
const effectiveDate = (version) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(version || '');
  if (!m) return null;
  return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
};

const LegalLayout = ({ title, lastUpdated, version, children }) => (
  <div style={{ minHeight: '100vh', background: '#F6F7FA' }}>
    <header style={{
      background: '#0B1A35',
      padding: '14px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
        <img src="/logo-wide.png" alt="HoopHero" style={{ height: '32px', width: 'auto' }} />
      </Link>
      <Link to="/" style={{
        fontSize: '13px',
        color: 'rgba(255,255,255,0.7)',
        textDecoration: 'none',
        fontWeight: '500',
      }}>
        ← Back to HoopHero
      </Link>
    </header>

    <main style={{
      maxWidth: '780px',
      margin: '0 auto',
      padding: '40px 24px 80px',
    }}>
      <h1 style={{
        fontFamily: 'Georgia, serif',
        fontSize: '32px',
        fontWeight: '800',
        color: '#0D1117',
        margin: '0 0 8px',
      }}>
        {title}
      </h1>
      <p style={{
        fontSize: '13px',
        color: '#9AA0B0',
        margin: '0 0 32px',
      }}>
        {version ? `Version ${version} · effective ${effectiveDate(version)}` : `Last updated: ${lastUpdated}`}
      </p>

      <div style={{
        fontSize: '15px',
        color: '#2A3140',
        lineHeight: '1.7',
      }}>
        {children}
      </div>
    </main>

    <footer style={{
      borderTop: '1px solid rgba(0,0,0,0.06)',
      padding: '24px',
      textAlign: 'center',
      fontSize: '12.5px',
      color: '#9AA0B0',
    }}>
      © 2026 Clarity Growth Pro LLC · HoopHero · <Link to="/terms" style={{ color: '#9AA0B0', textDecoration: 'underline' }}>Terms</Link> · <Link to="/privacy" style={{ color: '#9AA0B0', textDecoration: 'underline' }}>Privacy</Link> · <Link to="/sms" style={{ color: '#9AA0B0', textDecoration: 'underline' }}>Text messages</Link>
    </footer>
  </div>
);

// Internal styling helpers — keeps the JSX of the two legal docs readable
// (just <Section>, <P>, <UL> instead of repeating the same inline styles).
export const Section = ({ id, heading, children }) => (
  <section id={id} style={{ marginBottom: '36px' }}>
    <h2 style={{
      fontFamily: 'Georgia, serif',
      fontSize: '22px',
      fontWeight: '700',
      color: '#0D1117',
      margin: '0 0 12px',
    }}>
      {heading}
    </h2>
    {children}
  </section>
);

export const P = ({ children }) => (
  <p style={{ margin: '0 0 14px' }}>{children}</p>
);

export const UL = ({ children }) => (
  <ul style={{ margin: '0 0 14px', paddingLeft: '24px' }}>{children}</ul>
);

export const LI = ({ children }) => (
  <li style={{ margin: '0 0 8px' }}>{children}</li>
);

export const Strong = ({ children }) => (
  <strong style={{ color: '#0D1117' }}>{children}</strong>
);

export default LegalLayout;
